'use client';

import { useRef } from 'react';

import PDPTechSpecsSection from '@/app/[locale]/store/_components/HardwarePDP/PDPTechSpecsSection';
import getHighlightedFeaturesSections from '@/app/[locale]/store/rings/_components/data/getHighlightedFeaturesSections';
import { getPdpTechSpecsSectionData } from '@/app/[locale]/store/rings/oura-ring-4/(pdp)/_data/getPdpTechSpecsSectionData';
import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';
import useAuroraRollout from '@/app/hooks/useAuroraRollout';
import usePartnerUtm from '@/app/hooks/usePartnerUtm/usePartnerUtm';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import accuracyComfortSections from './_components/data/accuracyComfortSections';
import finishesCarouselSlides from './_components/data/finishesCarouselSlides';
import PopAccuracyComfort from './_components/PopAccuracyComfort';
import PopFinishes from './_components/PopFinishes';
import PopHero from './_components/PopHero';
import PopHighlightedFeatures from './_components/PopHighlightedFeatures';
import PopMembership from './_components/PopMembership';
import PopPostHero from './_components/PopPostHero';

const getFeaturesTValues = () => ({
  battery: {
    FootnoteLink: () => (
      <sup>
        <a href={`#${LEGAL_FOOTNOTES_ID}`}>*</a>
      </sup>
    ),
  },
});

const Content = () => {
  const popPostHeroRef = useRef<HTMLDivElement>(null);
  const isAuroraEnabled = useAuroraRollout();
  const highlightedFeaturesSections =
    getHighlightedFeaturesSections(isAuroraEnabled);

  // Persist UTM query param data to localStorage (if any params exist)
  usePartnerUtm();
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="content-pop-ring-gen4">
      <div className="lg:bg-[linear-gradient(45deg,rgba(192,139,48,0.8)_-25%,transparent_60%)]">
        <PopHero />
        <PopPostHero ref={popPostHeroRef} />
        <PopAccuracyComfort sections={accuracyComfortSections} />
      </div>
      <PopHighlightedFeatures sections={highlightedFeaturesSections} />
      <PopFinishes carouselSlides={finishesCarouselSlides} />
      <PopMembership />
      <PDPTechSpecsSection
        {...getPdpTechSpecsSectionData({
          featuresTValues: getFeaturesTValues(),
        })}
      />
    </div>
  );
};

export default Content;
